import React from 'react';
import {
    Responsive,
    SimpleList,
    TextField,
    SimpleForm,
    TextInput,
    required
} from 'admin-on-rest';
import List from '../admin/List';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import DatagridName from '../admin/DatagridName';
import ValidatedLocationTextInput from '../components/ValidatedLocationTextInput';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/editor/attach-money';

export const fuseLocationPriceLevelIcon = Icon;

/*
 * View: List
 */

// Set title for List Locations
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Price Levels</span>;

const ListDescription = () => {
    return (
        <span>
            <p>A <strong>Price Level</strong> is used to label a <em>Price Level Price</em> of a Product. Certain
                Locations or DBAs could have different pricing of products, so Products can have Price Level Prices
                based on a certain Price Level.</p>
            <ul>
                <li>If a Location or a DBA has a Price Level, the POS System will display the Price Level Price of a
                    Product instead of its default price.</li>
                <li>If a Location has a Price Level but a Product doesn't have a Price Level Price, then the Product's
                    default price will display on the POS System.</li>
            </ul>
            <p>Price Levels cannot be edited. If a Price Level does not have your desired name, create a new Price
                Level.</p>
            <img src="img-diagram-Price-Level-List.png" alt="Diagram of Locations - Price Levels"
                 style={viewStyles.diagram}/>
        </span>
    );
};

const ListDescriptionViewOnly = () => {
    return (
        <span>
            <p>A <strong>Price Level</strong> is used to label a <em>Price Level Price</em> of a Product. Certain
                Locations or DBAs could have different pricing of products, so Products can have Price Level Prices
                based on a certain Price Level.</p>
            <ul>
                <li>If a Location or a DBA has a Price Level, the POS System will display the Price Level Price of a
                    Product instead of its default price.</li>
                <li>If a Location has a Price Level but a Product doesn't have a Price Level Price, then the Product's
                    default price will display on the POS System.</li>
            </ul>
            <img src="img-diagram-Price-Level-List.png" alt="Diagram of Locations - Price Levels"
                 style={viewStyles.diagram}/>
        </span>
    );
};

export const fusePriceLevelList = (props) => (
    <List title={ListTitle} desc={<ListDescription/>} sort={{field: 'name', order: 'ASC'}} {...props}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                />
            }
            medium={
                <DatagridName bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                </DatagridName>
            }
        />
    </List>
);

export const fusePriceLevelListViewOnly = (props) => (
    <List title={ListTitle} desc={<ListDescriptionViewOnly/>} sort={{field: 'name', order: 'ASC'}} {...props}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                />
            }
            medium={
                <DatagridName bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                </DatagridName>
            }
        />
    </List>
);

/*
 * View: Create form
 */

// Set title for Create Price Level
const CreateTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                  className="avatar-title"/>Create a Price Level</span>;

const CreateDescription = () => {
    return (
        <span>
            <p>Create a Price Level by adding a Name. This will act as a label for a Location's Price Level, a DBA's
                Price Level, or the Price Level Price for a Product Unit. The Name must be unique.</p>
        </span>
    );
};

/*
 * Create Price Level form
 */
export const fusePriceLevelCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm redirect="list">
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
            <span style={viewStyles.fieldDescription}>
                Enter a unique <strong>Price Level</strong> Name and check its availability.
            </span>
            <ValidatedLocationTextInput
                source="name"
                fieldType="text"
                label="Name of Price Level*"
                buttonLabel="Check Availability"
                successMessage="This Price Level Name is available."
                errorDuplicateMessage="A Price Level with this Name already exists."
                errorValidateMessage="This value must be verified."
                fieldResource="PriceLevels"
                isRequired={true}
            />
        </SimpleForm>
    </Create>
);

/*
 * View: Edit form
 */

// Set title for Edit Price Level
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.name}` : 'Price Level'}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Modify Name field below. If the Name is edited, this will create a new Price Level of that name, while
                the old name remains. Click <strong>Save</strong> to create a new Price Level.</p>
        </span>
    );
};

/*
 * Edit Price Level form
 */
export const fusePriceLevelEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm>
            <TextInput source="name" label="Name of Price Level" validate={[required]}/>
            <span style={viewStyles.fieldDescription}>(Editing a Price Level name will create a new Price Level of that name.)</span>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Location/priceLevel.js